import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query cardLimits($cardId: ID!) {
      cardLimits(cardId: $cardId) {
        groupLimitId
        groupLimitName
        limitId
        limitStartDate
        limitDays
        limitDaysThreshold
        limitAmount
        limitAmountThreshold
        limitType
        limitPeriodType
        isIndividual
      }
    }
  `,
  config: {
    skip: (ownProps) => ownProps.skip,
    options: ({ cardId }) => ({
      pollInterval: 300000,
      errorPolicy: "none",
      notifyOnNetworkStatusChange: true,
      variables: {
        cardId,
      },
    }),
  },
  propTypes: {
    skip: PropTypes.bool,
    cardId: PropTypes.string.isRequired,
  },
  isLoaded: (data) => {
    return !!data.cardLimits;
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/cardLimits.js